module.exports = __webpack_public_path__ + "img/ChemReliant.3f47007b.png";